import { Component, Shark, Utils } from "shark-mvc";
import { Modal } from "bootstrap";

import User from "../../models/User";
import UserPermission from "../../models/UserPermission";

import templateContent from "./activity-settings-modal.html";

import userManager from "../../controllers/userManager";
import userPermissionManager from "../../controllers/userPermissionManager";

class ActivitySettingsComponent extends Component {
	constructor () {
		super("activitySettingsComponent");
		this.addTemplate("", templateContent);
	}

	afterLoad () {
		const modalNode = document.querySelector("#activitySettingsModal");

		if (modalNode) {
			this.modal = new Modal(modalNode, {
				keyboard: false
			});
		}
	}

	afterRender () {
		const allTaskPermissionsChk = document.querySelector(`[data-sh-prop="__allTaskPermissions"]`);

		if (allTaskPermissionsChk) {
			const { editingSettingsActivity } = Shark.get();
			allTaskPermissionsChk.indeterminate = editingSettingsActivity.__allTaskPermissionsIndeterminate;
		}
	}

	close () {
		if (this.modal) {
			this.modal.hide();
			this.set("open", false);
		}

		Shark.set({
			userAssigningPermissions: null,
		});
	}
	
	closeActivitySettingsModalBtn_clickHandler () {
		this.close();
	}
	
	async init () {
		this.set("open", false);

		const { otherUserList } = Shark.get();

		if (!otherUserList || otherUserList.length === 0) {
			const userListResponse = await userManager.getList();
			const otherUserList = Shark.getInstanceList(User, userListResponse.data.filter(item => item.guid !== Shark.$store.loggedUser.guid));

			otherUserList.forEach(item => item.cssClasses = "");

			Shark.set({
				otherUserList,
				saveButtonStatusCSSClass: "btn-primary",
			});
		}

		Shark.set({
			editingSettingsActivity: null,//Questo non triggera il render, perchè?
		});
	}
	
	async open (activity) {
		const projectPermissionResponse = await userPermissionManager.getListByProjectGuid(activity.projectGuid);
		const activityPermissionResponse = await userPermissionManager.getListByActivityGuid(activity.guid);
		const permissionMap = new Map();

		// {"permissions":["access","addActivity","editActivity","addTask"]}

		projectPermissionResponse.data.forEach(item => {
			const inheritedPermission = new UserPermission({
				...item,
				guid: "",
				referenceGuid: activity.guid,
				type: "activity",
				__inherited: true}
			);

			inheritedPermission.settings.permissions = inheritedPermission.settings.permissions.filter(item => !item.includes("Activity"));

			permissionMap.set(item.userGuid, inheritedPermission);
		});
		activityPermissionResponse.data.forEach(item => {
			permissionMap.set(item.userGuid, new UserPermission(item));
		});

		activity.set({
			__userAccessPermissions: permissionMap,
		});
		console.log({permissionMap});

		Shark.set({
			editingSettingsActivity: activity,
			saveButtonStatusCSSClass: "btn-secondary disabled",
		});

		if (this.modal) {
			this.modal.show();
			this.set("open", true);
		}
	}

	async saveActivityPermissions () {
		const { editingSettingsActivity } = Shark.get();

		if (editingSettingsActivity) {
			Shark.set({
				saveButtonStatusCSSClass: "btn-warning disabled",
			});

			const userPermissions = Array.from(editingSettingsActivity.__userAccessPermissions.values());
			console.log({userPermissions});

			const saveResponse = await userPermissionManager.saveMulti(userPermissions);
			console.log({saveResponse});
			Shark.set({
				saveButtonStatusCSSClass: "btn-success",
			});
			setTimeout(() => {
				Shark.set({
					saveButtonStatusCSSClass: "btn-primary",
				});
				this.close();
			}, 1000);
		}
	}

	saveActivityPermissionsBtn_clickHandler () {
		this.saveActivityPermissions();
	}

	selectSingleUserBtn_clickHandler (event, data) {
		const userGuid = data.guid;
		const user = Utils.safp(Shark.$store.userList, "guid", userGuid);

		if (user) {
			const { editingSettingsActivity, otherUserList } = Shark.get();

			otherUserList.forEach(item => item.cssClasses = item.guid === userGuid ? "bg-light" : "");

			Shark.set({
				saveButtonStatusCSSClass: "btn-primary",
				userAssigningPermissions: user,
			});
			editingSettingsActivity.checkPermissionForUser();
			// Shark.render();
		}
	}
}

const activitySettingsComponent = new ActivitySettingsComponent();

Shark.registerComponent(activitySettingsComponent);

export default activitySettingsComponent;
